// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".heat-content[data-v-99d2d986]{height:100vh;width:100vw;background-color:#fff}.download-svg-css[data-v-99d2d986]{width:1280px;height:768px;z-index:-1;position:absolute;top:50px}", ""]);
// Exports
module.exports = exports;
